// Adapted from davinci-elections apps/web/src/theme/recipes/progress.ts @ 6e23f58
import { defineSlotRecipe } from '@chakra-ui/react'
import { progressAnatomy } from '@chakra-ui/react/anatomy'

export const Progress = defineSlotRecipe({
  slots: progressAnatomy.keys(),
  variants: {
    size: {
      xs: {},
      sm: {},
      md: {},
      lg: {},
    },
  },
})
